"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/PaymentFailure.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PaymentFailure = function PaymentFailure(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 145.95 136.47"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Payment Failure Icon"), _react2.default.createElement("path", {
    className: "credit_card_failure",
    d: "M131.93 80.23l10-5a5.55 5.55 0 0 0 2.5-7.43L112.21 2.89a5.46 5.46 0 0 0-7.43-2.26l-78 39.1H6.41C3 39.73 0 42 0 45.33v71.42a6.28 6.28 0 0 0 6.41 6h83.45a31.22 31.22 0 0 0 25.49 13.74 30.55 30.55 0 0 0 16.58-56.26zm-.49 38.84l-3 3-13.13-13.13L102.23 122l-3-3 13.13-13.13-13.09-13.06 3-3L115.36 103l13.13-13.13 3 3L118.36 106zM107 5a.59.59 0 0 1 .83.16L140 70.09a.54.54 0 0 1 0 .44.59.59 0 0 1-.3.34l-13.2 6.58a18.79 18.79 0 0 0-2.5-.87V45.33c0-3.36-2.8-5.6-6.16-5.6h-80zM5 45.33a1.87 1.87 0 0 1 1.41-1.6h111.43a1.65 1.65 0 0 1 1.16 1.6v30.24a27.43 27.43 0 0 0-3.64-.33 29.53 29.53 0 0 0-16.11 4.48H5V45.33zm0 39.4h88.2a30.4 30.4 0 0 0-7.7 15H5v-15zm1.41 33a1.28 1.28 0 0 1-1.41-1v-12h79.82a11 11 0 0 0 0 1.36 26.62 26.62 0 0 0 2.43 11.64H6.41z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = PaymentFailure;